import Tooltip from "@/components/atoms/Tooltip/Tooltip";
import { cn } from "@/lib/utils";

import { evosIcon } from "../../../icons";

type Props = {
  type: "info" | "warning";
};
export const InfoIcon = ({ type }: Props) => (
  // <Tooltip
  //   open={true}
  //   content={
  //     <div className="flex flex-col text-sm p-2 rounded-lg gap-y-1 w-64">
  //       <p className="font-bold">No Evolution Path found</p>
  //       <p>Sorry, there are no evolution paths available for this player</p>
  //     </div>
  //   }
  //   side="bottom"
  //   delayDuration={100}
  // >
  <div
    className={cn(
      "w-7 h-7 brightness-75",
      // "hover:brightness-100",
      type === "warning" && "text-[#F83959CC]",
      type === "info" && "text-white",
    )}
  >
    {evosIcon}
  </div>
  // </Tooltip>
);
